import { usePortalClient } from '../hooks/usePortalClient'
import ClientPolicies from '../../policies/pages/ClientPolicies'

function PortalPolicies() {
  const { clientId } = usePortalClient()

  return <ClientPolicies clientIdProp={clientId} />
}

export default PortalPolicies
